module.exports = __webpack_public_path__ + "assets/images/pl/logo_horizontal_white.png";